import RouterView from '@/views/RouterView.vue'
import i18next from 'i18next'
import i18nextConfig from '@/helpers/i18next-config'
import {RouteConfig} from "vue-router";

i18next.init(i18nextConfig)

export const routes: RouteConfig[] = [
  {
    path: '/',
    component: RouterView,
    children: [
      {
        path: '/',
        name: i18next.t('Overview'),
        meta: { title: `ModTools - ${i18next.t('Overview')} | Freecycle` },
        component: (): Promise<typeof import("@/views/home/Overview.vue")> => import('@/views/home/Overview.vue')
      },
      {
        path: 'preferences',
        name: i18next.t('Preferences'),
        meta: { title: `ModTools - ${i18next.t('Preferences')} | Freecycle` },
        component: (): Promise<typeof import("@/views/home/Preferences.vue")> => import('@/views/home/Preferences.vue')
      }
    ] as unknown as undefined
  },
  {
    path: '/towns',
    component: RouterView,
    children: [
      {
        path: ':townName',
        redirect: '/towns/:townName/posts',
        component: RouterView,
        children: [
          {
            path: 'members',
            component: RouterView,
            children: [
              {
                path: '/',
                name: i18next.t('Approve Members'),
                meta: { title: `ModTools - ${i18next.t('Approve Members')} | Freecycle` },
                component: (): Promise<typeof import("@/views/town/members/ApproveMembers.vue")> => import('@/views/town/members/ApproveMembers.vue')
              },
              {
                path: 'invite',
                name: i18next.t('Invite Members'),
                meta: { title: `ModTools - ${i18next.t('Invite Members')} | Freecycle` },
                component: (): Promise<typeof import("@/views/town/members/InviteMembers.vue")> => import('@/views/town/members/InviteMembers.vue')
              },
              {
                path: 'search',
                name: i18next.t('Search Members'),
                meta: { title: `ModTools - ${i18next.t('Search Members')} | Freecycle` },
                component: (): Promise<typeof import("@/views/town/members/SearchMembers.vue")> => import('@/views/town/members/SearchMembers.vue')
              },
              {
                path: ':userId',
                name: i18next.t('Member Profile'),
                meta: { title: `ModTools - ${i18next.t('Member Profile')} | Freecycle` },
                component: (): Promise<typeof import("@/views/town/members/MemberProfile.vue")> => import('@/views/town/members/MemberProfile.vue'),
                children: [
                  {
                    path: 'posts/:postId/preview',
                    name: i18next.t('Members Post Preview'),
                    meta: { title: `ModTools - ${i18next.t('Members Post Preview')} | Freecycle` },
                    component: (): Promise<typeof import("@/components/PostPreview.vue")> => import('@/components/PostPreview.vue')
                  }
                ]
              }
            ]
          },
          {
            path: 'posts',
            component: RouterView,
            children: [
              {
                path: '/',
                name: i18next.t('Approve Posts'),
                meta: { title: `ModTools - ${i18next.t('Approve Posts')} | Freecycle` },
                component: (): Promise<typeof import("@/views/town/posts/ApprovePosts.vue")> => import('@/views/town/posts/ApprovePosts.vue'),
                children: [
                  {
                    path: ':postId/preview',
                    name: i18next.t('Posts Post Preview'),
                    meta: { title: `ModTools - ${i18next.t('Posts Post Preview')} | Freecycle` },
                    component: (): Promise<typeof import("@/components/PostPreview.vue")> => import('@/components/PostPreview.vue')
                  }
                ]
              },
              {
                path: 'search',
                name: 'TownPostsSearch',
                meta: { title: `ModTools - ${i18next.t('Search Posts')} | Freecycle` },
                component: (): Promise<typeof import("@/views/town/posts/SearchPosts.vue")> => import('@/views/town/posts/SearchPosts.vue'),
                children: [
                  {
                    path: 'results/:postId/preview',
                    name: i18next.t('Preview'),
                    meta: { title: `ModTools - ${i18next.t('Post Preview')} | Freecycle` },
                    component: (): Promise<typeof import("@/components/PostPreview.vue")> => import('@/components/PostPreview.vue')
                  }
                ]
              },
              {
                path: ':postId/edit',
                name: i18next.t('Edit Post'),
                meta: { title: `ModTools - ${i18next.t('Edit Post')} | Freecycle` },
                component: (): Promise<typeof import("@/views/town/posts/EditPost.vue")> => import('@/views/town/posts/EditPost.vue')
              }
            ]
          },
          {
            path: 'settings',
            component: RouterView,
            children: [
              {
                path: '/',
                name: i18next.t('Town Settings'),
                meta: { title: `ModTools - ${i18next.t('Town Settings')} | Freecycle` },
                component: (): Promise<typeof import("@/views/town/settings/General.vue")> => import('@/views/town/settings/General.vue')
              },
              {
                path: 'activity',
                name: i18next.t('Town Activity'),
                meta: { title: `ModTools - ${i18next.t('Town Activity')} | Freecycle` },
                component: (): Promise<typeof import("@/views/town/settings/Activity.vue")> => import('@/views/town/settings/Activity.vue')
              },
              {
                path: 'notices',
                name: i18next.t('Town Notices'),
                meta: { title: `ModTools - ${i18next.t('Town Notices')} | Freecycle` },
                component: (): Promise<typeof import("@/views/town/settings/Notices.vue")> => import('@/views/town/settings/Notices.vue'),
                children: [
                  {
                    path: 'automation',
                    name: i18next.t('Automated Notices'),
                    meta: { title: `ModTools - ${i18next.t('Automated Notices')} | Freecycle` },
                    component: (): Promise<typeof import("@/views/town/settings/NoticeAutomation.vue")> => import('@/views/town/settings/NoticeAutomation.vue')
                  }
                ]
              },
              {
                path: 'notices/add',
                name: i18next.t('Add Notice'),
                meta: { title: `ModTools - ${i18next.t('Add Notice')} | Freecycle` },
                component: (): Promise<typeof import("@/views/town/settings/NoticeAdd.vue")> => import('@/views/town/settings/NoticeAdd.vue'),
              },
              {
                path: 'notices/:noticeId/edit',
                name: i18next.t('Edit Notice'),
                meta: { title: `ModTools - ${i18next.t('Edit Notice')} | Freecycle` },
                component: (): Promise<typeof import("@/views/town/settings/NoticeEdit.vue")> => import('@/views/town/settings/NoticeEdit.vue'),
              },
              {
                path: 'hotwords',
                name: i18next.t('Hotwords'),
                meta: { title: `ModTools - ${i18next.t('Hotwords')} | Freecycle` },
                component: (): Promise<typeof import("@/views/town/settings/Hotwords.vue")> => import('@/views/town/settings/Hotwords.vue')
              }
            ]
          }
        ]
      }
    ] as unknown as undefined  // i don't like having to do this. but i don't understand
  },
  {
    path: '*',
    name: `${i18next.t('Not Found')}`,   // wrap in template cuz typescripts wants this to be for sure a string.
    meta: { title: `ModTools - ${i18next.t('Not Found')} | Freecycle` },
    component: (): Promise<typeof import("@/views/NotFound.vue")> => import('@/views/NotFound.vue')
  }
]
